<div>
  <div *ngIf="backToList" class="d-inline-flex {{subMenu ? 'underline-pill-tabs' : ''}}">
    <ul class="{{subMenu ? 'nav-tabs nav-pill' : 'nav nav-tabs nav-pill d-flex text-center styleguide-tabs'}}">
      <li class="{{ subMenu ? 'nav-item text-center' : 'nav-item mr-3'}}">
        <a [routerLink]="baseUrl" class="nav-link"><i class="fas fa-angle-left mr-2"></i>{{ 'Back to list' | translate
          }}</a>
      </li>
    </ul>
  </div>
  <div *ngFor="let item of items; let i = index;" class="d-inline-flex {{subMenu ? 'underline-pill-tabs' : ''}}">
    <ul class="{{subMenu ? 'nav-tabs nav-pill' : 'nav nav-tabs nav-pill d-flex text-center styleguide-tabs'}}">
      <li class="{{ subMenu ? 'nav-item text-center' : 'nav-item mr-3'}}" (click)="resetSections()">
        <a class="{{ subMenu ? 'nav-link overflow-hide' : 'nav-link' }} {{item.disabled ? 'disabled' : ''}}"
          [routerLinkActive]="['active']" [routerLink]="item.disabled ? null : baseUrl + '/' + item.id"
          tooltip="{{item.name ? item.name : ''}}" placement="right">
          {{ (item.shortName ? item.shortName : (item.name ? item.name : item.content)) | translate}}
        </a>
      </li>
    </ul>
  </div>
</div>